import { useMemo, useState } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { useLang } from '../../../../../../hooks/use-lang';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';
import { generateColors } from '../../dashboard-helpers';
import { LangType } from '../../../../../../helpers/lang';
import { useFetchDashboardData } from '../../use-fetch-dashboard';

interface DataType {
  categories: LangType[];
  count: number[];
}

export const usePopularOrders = (): ChartProps => {
  const { t, getLocale } = useLang();
  const [sectionIds, setSectionIds] = useState<string[]>([]);

  const { list } = useFetchDashboardData(['popular_dishes'], {
    section_ids: sectionIds.length ? sectionIds : undefined,
  });

  const data = list?.popular_dishes as DataType;

  const chartData: ReactApexChartProps = useMemo(() => {
    const series = data?.count;
    const labels = data?.categories.map((category) => getLocale(category));

    return {
      series: series,
      options: {
        chart: {
          type: 'donut',
          toolbar: {
            show: false,
          },
        },
        responsive: [
          {
            breakpoint: 1000,
            options: {
              legend: {
                position: 'right',
                verticalAlign: 'middle',
              },
            },
          },
        ],
        tooltip: {
          enabled: true,
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  label: t('Позиции'),
                  color: '#000',
                  fontSize: '20px',
                  formatter: (w) => {
                    const total = w.globals.seriesTotals.reduce((a: number, b: number) => a + b, 0);
                    return `${total}`;
                  },
                },
              },
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return String(val);
            },
          },
        },
        legend: {
          position: 'bottom',
          formatter: (seriesName, opts) =>
            `${seriesName}: ${opts.w.globals.series[opts.seriesIndex]}`,
        },
        labels: labels,
        colors: generateColors(labels?.length),
      },
    };
  }, [getLocale, t, data]);

  return {
    series: chartData.series,
    options: chartData.options,
    label: 'Популярность позиций в категориях',
    subLabel:
      'Круговая диаграмма заказов по категориям меню демонстрирует распределение популярности позиции. На ней наглядно видно, какие категории пользуются наибольшим спросом',
    type: 'donut',
    filters: {
      sections: {
        onChangeSectionIds: setSectionIds,
        sectionIds,
      },
    },
  };
};
